module.exports = __webpack_public_path__ + "static/media/push-pin-off.9a37ef20.svg";